/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { computeSecretsGetComputeSecret } from "../../funcs/computeSecretsGetComputeSecret.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetComputeSecretRequest$inboundSchema,
};

export const tool$computeSecretsGetComputeSecret: ToolDefinition<typeof args> =
  {
    name: "compute-secrets-get-compute-secret",
    description: `Get a secret`,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] = await computeSecretsGetComputeSecret(
        client,
        args.request,
        { fetchOptions: { signal: ctx.signal } },
      ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };
